/* ================================================================
   Herb Terra PDP Interactions
   Tabs, animated charts, counters, FAQ, review carousel,
   timeline, deficiency checker. All IntersectionObserver-powered.
   ================================================================ */

(function() {
  'use strict';

  /* ── Tabs ───────────────────────────────────────────────────── */
  function initTabs() {
    var tabContainers = document.querySelectorAll('.htc-pdp-tabs');
    tabContainers.forEach(function(container) {
      var btns = container.querySelectorAll('.htc-pdp-tabs__btn');
      var panels = container.querySelectorAll('.htc-pdp-tabs__panel');

      btns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var target = this.getAttribute('data-tab');

          btns.forEach(function(b) { b.classList.remove('htc-pdp-tabs__btn--active'); });
          panels.forEach(function(p) { p.classList.remove('htc-pdp-tabs__panel--active'); });

          this.classList.add('htc-pdp-tabs__btn--active');
          var panel = container.querySelector('[data-tab-panel="' + target + '"]');
          if (panel) panel.classList.add('htc-pdp-tabs__panel--active');
        });
      });
    });
  }


  /* ── Animated Counters ──────────────────────────────────────── */
  function initCounters() {
    var counters = document.querySelectorAll('[data-count]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    counters.forEach(function(el) { observer.observe(el); });
  }

  function animateCounter(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var suffix = el.getAttribute('data-suffix') || '';
    var prefix = el.getAttribute('data-prefix') || '';
    var decimals = (target % 1 !== 0) ? 2 : 0;
    var duration = 1200;
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = start + (target - start) * eased;
      el.textContent = prefix + current.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.classList.add('htc-counted');
      }
    }

    el.style.opacity = '1';
    requestAnimationFrame(step);
  }


  /* ── Animated Charts ────────────────────────────────────────── */
  function initCharts() {
    var charts = document.querySelectorAll('.htc-pdp-chart');
    if (!charts.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('htc-animated');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    charts.forEach(function(chart) { observer.observe(chart); });
  }


  /* ── FAQ Accordion ──────────────────────────────────────────── */
  function initFaq() {
    var questions = document.querySelectorAll('.htc-pdp-faq__question');
    questions.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = this.closest('.htc-pdp-faq__item');
        var wasOpen = item.classList.contains('htc-pdp-faq__item--open');

        // Close all
        document.querySelectorAll('.htc-pdp-faq__item--open').forEach(function(open) {
          open.classList.remove('htc-pdp-faq__item--open');
        });

        // Toggle clicked
        if (!wasOpen) {
          item.classList.add('htc-pdp-faq__item--open');
        }
      });
    });
  }


  /* ── Timeline Stagger ───────────────────────────────────────── */
  function initTimeline() {
    var items = document.querySelectorAll('.htc-pdp-timeline__item');
    if (!items.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Stagger the children
          var parent = entry.target;
          var children = parent.querySelectorAll('.htc-pdp-timeline__item');
          if (!children.length) children = [parent];
          children.forEach(function(child, i) {
            setTimeout(function() {
              child.classList.add('htc-visible');
            }, i * 150);
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    // Observe the container
    var container = document.querySelector('.htc-pdp-timeline__items');
    if (container) observer.observe(container);
  }


  /* ── Scroll Reveal ──────────────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.htc-pdp-reveal');
    if (!els.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('htc-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

    els.forEach(function(el) { observer.observe(el); });
  }


  /* ── Deficiency Checker ─────────────────────────────────────── */
  function initDeficiencyChecker() {
    var items = document.querySelectorAll('.htc-pdp-deficiency__item');
    var result = document.querySelector('.htc-pdp-deficiency__result');
    var resultText = document.querySelector('.htc-pdp-deficiency__result-text');
    var resultSub = document.querySelector('.htc-pdp-deficiency__result-sub');
    if (!items.length || !result) return;

    items.forEach(function(item) {
      item.addEventListener('click', function() {
        this.classList.toggle('htc-pdp-deficiency__item--selected');
        updateResult();
      });
    });

    var initialText = resultText ? resultText.textContent : '';
    var initialSub = resultSub ? resultSub.textContent : '';
    var manyText = result.getAttribute('data-result-many-text') || '';
    var manySub = result.getAttribute('data-result-many-sub') || '';
    var fewText = result.getAttribute('data-result-few-text') || '';
    var fewSub = result.getAttribute('data-result-few-sub') || '';

    function updateResult() {
      var selected = document.querySelectorAll('.htc-pdp-deficiency__item--selected').length;
      if (selected >= 2) {
        result.classList.add('htc-pdp-deficiency__result--visible');
        if (selected >= 4 && manyText) {
          resultText.textContent = manyText.replace('{n}', selected);
          resultSub.textContent = manySub.replace('{n}', selected);
        } else if (fewText) {
          resultText.textContent = fewText.replace('{n}', selected);
          resultSub.textContent = fewSub.replace('{n}', selected);
        } else {
          resultText.textContent = initialText;
          resultSub.textContent = initialSub;
        }
      } else {
        result.classList.remove('htc-pdp-deficiency__result--visible');
        resultText.textContent = initialText;
        resultSub.textContent = initialSub;
      }
    }
  }


  /* ── Final CTA Button → scroll to buy box ───────────────────── */
  function initFinalCta() {
    var ctaBtn = document.querySelector('.htc-pdp-final-cta__btn');
    if (!ctaBtn) return;

    ctaBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var productForm = document.querySelector('.product-form');
      var submitBtn = productForm ? productForm.querySelector('[type="submit"], .product-form__submit') : null;

      if (submitBtn) {
        submitBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Flash the button after scroll
        setTimeout(function() {
          submitBtn.style.transition = 'box-shadow 0.3s, transform 0.3s';
          submitBtn.style.boxShadow = '0 0 0 4px rgba(45, 106, 79, 0.3)';
          submitBtn.style.transform = 'scale(1.02)';
          setTimeout(function() {
            submitBtn.style.boxShadow = '';
            submitBtn.style.transform = '';
          }, 800);
        }, 600);
      }
    });
  }


  /* ── Supplement Facts Variant Sync ────────────────────────────── */
  function initSupplementFacts() {
    var toggle = document.getElementById('htcSfactToggle');
    var panel60 = document.getElementById('htcSfact60');
    var panel100 = document.getElementById('htcSfact100');
    if (!toggle || !panel60 || !panel100) return;

    var sfactBtns = toggle.querySelectorAll('.htc-sfact-toggle__btn');

    function showSfactPanel(count) {
      sfactBtns.forEach(function(b) {
        b.classList.toggle('htc-sfact-toggle__btn--active', b.getAttribute('data-sfact') === count);
      });
      panel60.style.display = count === '60' ? '' : 'none';
      panel100.style.display = count === '100' ? '' : 'none';
    }

    // Manual toggle clicks
    sfactBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        showSfactPanel(this.getAttribute('data-sfact'));
      });
    });

    function syncFromBuyBox() {
      var sel = document.querySelector('.product-form [name="id"]');
      if (!sel) return;
      var opt = sel.options ? sel.options[sel.selectedIndex] : null;
      var txt = opt ? opt.textContent : sel.value;
      // Also check radio/button variant pickers
      if (!txt || txt === sel.value) {
        var checked = document.querySelector('.product-form__input input:checked');
        if (checked) txt = checked.value;
      }
      if (txt && txt.indexOf('100') !== -1) showSfactPanel('100');
      else showSfactPanel('60');
    }

    // Listen for variant changes
    document.addEventListener('change', function(e) {
      if (e.target.name === 'id' || e.target.closest('.product-form')) {
        setTimeout(syncFromBuyBox, 30);
      }
    });
    document.addEventListener('click', function(e) {
      if (e.target.closest('.product-form__input')) {
        setTimeout(syncFromBuyBox, 80);
      }
    });

    // Initial sync
    syncFromBuyBox();
  }


  /* ── Subscription consent disclosure: collapse into <details> ── */
  function initBuyerConsent() {
    var el = document.getElementById('shopify-buyer-consent');
    if (!el || el.dataset.htcWrapped === '1') return;
    if (el.parentElement && el.parentElement.classList.contains('htc-buyer-consent')) return;

    var details = document.createElement('details');
    details.className = 'htc-buyer-consent';
    var summary = document.createElement('summary');
    summary.className = 'htc-buyer-consent__summary';
    summary.textContent = 'Subscription terms';
    details.appendChild(summary);

    el.parentNode.insertBefore(details, el);
    details.appendChild(el);
    el.dataset.htcWrapped = '1';
  }

  /* ── Init ────────────────────────────────────────────────────── */
  function init() {
    initTabs();
    initCounters();
    initCharts();
    initFaq();
    initTimeline();
    initReveal();
    initDeficiencyChecker();
    initFinalCta();
    initSupplementFacts();
    initBuyerConsent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
